import { ContentModel, InfoBarContentModel } from '@libs/cms/models';
import { TrackingDataFields } from '../../context';

interface ContentWithItems {
  items: TrackingDataFields[];
}

const isContentWithItems = (content: object): content is ContentWithItems => {
  return !!(content as ContentWithItems).items;
};

const isInfobarContent = (content: object): content is InfoBarContentModel => {
  return !!(content as InfoBarContentModel).infobars;
};

const getTrackingDataFields = (content: ContentModel): TrackingDataFields[] | undefined => {
  if (isContentWithItems(content)) {
    return content.items;
  }

  if (isInfobarContent(content)) {
    return content.infobars;
  }

  return undefined;
};

export function getCreativeSlot(context: ContentModel, contentItemId?: string): string {
  if (!contentItemId) {
    return '1';
  }

  const items: TrackingDataFields[] | undefined = getTrackingDataFields(context);

  if (!items?.length) {
    return '1';
  }

  const index: number = items.findIndex(item => item.id?.toString() === contentItemId);

  return index >= 0 ? String(index + 1) : '1';
}
